import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useUser } from './UserContext';
import api, { API_BASE_URL } from "../../src/utils/api";

const AddViolationForm = ({ member }) => {
  const { userFullName } = useUser();
  const [violationTypes, setViolationTypes] = useState([]);
  const [violationsHistory, setViolationsHistory] = useState([]);
  const [formData, setFormData] = useState({
    property_id: member.ClubMemberCode,
    account_id: member.ClubMemberCode,
    ccr_violation_type_id: '',
    inspection_id: '1',
    comment: '',
    upload_urls: null,
  });
  const [previewUrl, setPreviewUrl] = useState('');

  useEffect(() => {
    fetchViolationTypes();
    fetchViolationsHistory();
  }, []);

  useEffect(() => {
    if (userFullName) {
      setFormData((prev) => ({
        ...prev,
        cure_by: userFullName,
      }));
    }
  }, [userFullName]);
  

  const fetchViolationTypes = async () => {
    try {
      const response = await api.get(`/getCcrViolationTypes`);
      setViolationTypes(response.data);
    } catch (error) {
      console.error('Failed to fetch violation types:', error);
    }
  };

  const fetchViolationsHistory = async () => {
    try {
      console.log("Fetching violations for account_id:", member.ClubMemberCode); // ✅ Debugging
      const response = await api.get(`/getViolations`, {
        params: { account_id: String(member.ClubMemberCode).trim() } // ✅ Ensure it's a string
      });
      setViolationsHistory(response.data);
    } catch (error) {
      console.error('Failed to fetch violations history:', error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFormData(prev => ({ ...prev, upload_urls: file }));
    if (file) {
      const reader = new FileReader();
      reader.onload = () => setPreviewUrl(reader.result);
      reader.readAsDataURL(file);
    } else {
      setPreviewUrl('');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const formDataToSend = new FormData();
  
    // Add all form data
    Object.entries(formData).forEach(([key, value]) => {
      formDataToSend.append(key, value);
    });
  
    // Add cure_by from context here (safely)
    formDataToSend.append('cure_by', userFullName || 'Unknown User');
  
    console.log("Submitting form with:", {
      ...formData,
      cure_by: userFullName || 'Unknown User'
    });
  
    try {
      await api.post(`/addViolation`, formDataToSend, {
        headers: { "Content-Type": "multipart/form-data" }
      });
      alert('Violation added successfully');
      fetchViolationsHistory();
    } catch (error) {
      alert('Failed to add violation');
      console.error('Error:', error);
    }
  };
  

  return (
    
    <div className="violation-form-layout">
        <div className="form-and-history-container"></div>
      <div className="form-section">
        <form onSubmit={handleSubmit} className="profile-container">
          <h2 className="form-header">Add a Violation</h2>
          <div>
            <label>Violation Date and Time</label>
            <input type="datetime-local" name="violated_at" onChange={handleInputChange} />
          </div>
          <div>
            <label>Violation Type</label>
            <select name="ccr_violation_type_id" onChange={handleInputChange}>
              <option value="">Select a Type</option>
              {violationTypes.map(type => (
                <option key={type.id} value={type.id}>{type.title}</option>
              ))}
            </select>
          </div>
          <div>
            <label>Violation Photo Upload</label>
            <input type="file" name="upload_urls" onChange={handleFileChange} />
            {previewUrl && <img src={previewUrl} alt="Preview" style={{ width: '100px', height: '100px' }} />}
          </div>
          <div>
            <label>Violation Comment</label>
            <textarea name="comment" onChange={handleInputChange}></textarea>
          </div>
          <button type="submit">Add Violation</button>
        </form>
      </div>



      <div className="history-section">
        
  <h2>Violations</h2>
  <div class="status-icons">
    <div class="status-icon">
        <i class="fas fa-circle text-green"> </i>
        <span class="tooltip">Closed: This issue has been resolved.</span>
    </div>
    <div class="status-icon">
        <i class="fas fa-circle text-yellow"></i>
        <span class="tooltip">Open: This issue is currently open.</span>
    </div>
    <div class="status-icon">
        <i class="fas fa-circle text-red"></i>
        <span class="tooltip">Regression: The issue has reoccurred after being closed.</span>
    </div>
</div>
  {violationsHistory.length > 0 ? (
    <div className="violation-container">
      {violationsHistory.map(violation => {
  const violationType = violationTypes.find(type => type.id === violation.ccr_violation_type_id);
  return (
    <div className={`violation-history ${violation.status?.toLowerCase() || 'default'}`} key={violation.id}>
    <div className="violation-details">
      <span className="violation-id">VLT-{violation.id}</span>
      <span className="violation-type">{violationType ? violationType.title : 'Type Not Found'}</span>
      <span className="violation-date">{new Date(violation.violated_at).toLocaleDateString()}</span>

    </div>
    <div>
      
    
    </div>
    <button className="view-button">View</button>
  </div>
);
})}
    </div>
  ) : (
    <p>No historical violations found.</p>
  )}
</div>
    </div>
    
  );
};

export default AddViolationForm;
